import CajaMensualUpdate from './CajaMensualUpdate'
export {CajaMensualUpdate}
export default CajaMensualUpdate
